import { createFileRoute } from '@tanstack/react-router'

import { ParentEditView } from '@/modules/students'

export const Route = createFileRoute(
  '/_auth/students-and-classes/students/parents/$parentId/edit'
)({
  component: ParentEditView
})
